import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	noResultsPrimary: {
		id: 'dynamic-cards-search-page.no_results_primary',
		defaultMessage: "We couldn't find anything matching your search",
		description: 'Message shown when search request returns no results',
	},
});
